import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { ModalDialog, useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { useBooleanState } from 'libs.react';
import { getApiErrorMessage, getApiInstance } from '../../helpers/api.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
import { useSiteContext } from '../../hooks/use_site_context';
export const ResetPassword = ({ isModalOpen, participant, onClose }) => {
    const translate = useLocalizeMessage();
    const { addNotification } = useToastNotification();
    const { environment } = useCurrentEnvironment();
    const site = useSiteContext();
    const [newPassword, setNewPassword] = useState(null);
    const [isNewPasswordModalOpen, setIsNewPasswordModalOpen, setIsNewPasswordModalClose] = useBooleanState(false);
    const onHandleResetPassword = async () => {
        if (!environment) {
            throw new Error('Environment not defined');
        }
        try {
            const response = await getApiInstance(environment).post(`/routes/c_site/${site._id}/password_reset/${participant._id}`);
            addNotification({
                title: '',
                subtitle: translate('status.password_reset.success'),
                type: 'success',
            });
            setNewPassword(response.data.data.newPassword);
            setIsNewPasswordModalOpen();
        }
        catch (error) {
            addNotification({
                title: '',
                subtitle: getApiErrorMessage(error) ?? translate('error.participant.password_reset'),
                type: 'error',
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(ModalDialog, { title: translate('action.password_reset'), body: _jsx("div", { className: 'flex', children: translate('info.password_reset.description') }), width: 'lg', actionButtons: [
                    {
                        label: translate('generic.reset'),
                        onClick: onHandleResetPassword,
                    },
                    {
                        label: translate('generic.cancel'),
                        onClick: () => { },
                    },
                ], isOpen: isModalOpen, closeDialog: onClose, willCloseOnOutsideClickAndEscapeKeyPress: false }), isNewPasswordModalOpen && (_jsx(ModalDialog, { title: translate('action.password_reset'), body: _jsxs("div", { className: '', children: [_jsx("div", { className: 'pb-2', children: translate('info.password_reset.temp_password') }), _jsx("div", { className: 'nucleus-px-6 px-1 bg-neutral-100 w-fit', "data-testid": 'new-password', children: _jsx("span", { className: 'nucleus-text-h1 nucleus-font-light', children: newPassword }) })] }), width: 'lg', actionButtons: [
                    {
                        label: translate('generic.done'),
                        onClick: () => setNewPassword(null),
                    },
                ], isOpen: isNewPasswordModalOpen, closeDialog: setIsNewPasswordModalClose, willCloseOnOutsideClickAndEscapeKeyPress: false }))] }));
};
